import { render, staticRenderFns } from "./AtualizacaoDadosPessoais.vue?vue&type=template&id=155ebb35&"
import script from "./AtualizacaoDadosPessoais.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoDadosPessoais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports